import React, { useEffect, useState } from "react";
import Header from "../../layouts/Header";
import { Button, Col, Dropdown, Form, Modal, Row, Spinner, Table } from "react-bootstrap";
import axios from "../../api/axios";
import { toast } from "react-toastify";
import ReusableTable from "../../components/ReusableTable";
import { GoogleMap, MarkerF, useJsApiLoader } from "@react-google-maps/api";
import { useSelector } from "react-redux";
import Select from 'react-select';
import makeAnimated from "react-select/animated";

const Outlets = () => {
    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);
    const animatedComponents = makeAnimated();
    // Custom styles for react-select
    const customSelectStyles = {
        control: (base) => ({
            ...base,
            border: '1px solid #dee2e6',
            borderRadius: '0.375rem',
            minHeight: '38px',
            '&:hover': {
                borderColor: '#86b7fe',
            },
        }),
        placeholder: (base) => ({
            ...base,
            color: '#6c757d',
        }),
    };
    const { access } = useSelector((state) => state.login);
    const { email } = useSelector((state) => state.login);
    const [outletAccess, setOutletAccess] = useState([]);

    console.log("Access :", access);

    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("Outlet:")
            );
            setOutletAccess(filteredAccess);
        }
    }, [access]);

    console.log("Outlet Access:", outletAccess);


    const accessToken = localStorage.getItem("authToken");
    const [outlets, setOutlets] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openImageModal, setOpenImageModal] = useState(false);
    const [openUpdateImageModal, setOpenUpdateImageModal] = useState(false);
    const [outletImageId, setOutletImageId] = useState('');
    const [inputData, setInputData] = useState({
        name: "",
        phone: "",
        orderAcceptType: "",
        email: "",
        fssai: '',
        address: "",
        pincode: "",
        minimumDeliveryRadius: "",
        city: "",
        state: "",
        country: "",
        latitude: "",
        longitude: "",
        isEventOutlet: false,
        openingTime: '',
        closingTime: '',
        gstin: '',
        paymentType: "",
        menuGroup: "",
        type: "",
        foodUnitId: "",
        beverageUnitId: "",
        centralUnitId: "",
        pineLabCredentials: {
            merchantId: "",
            securityToken: "",
            clientId: "",
            storeId: ""
        },
        platForms: [{ name: "", webLink: "" }]
    });
    const [outletImage, setOutletImage] = useState(null);
    const [dataLoading, setDataLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isEditBtnLoading, setIsEditBtnLoading] = useState(false);
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);
    const [isUpdateImageBtnLoading, setIsUpdateImageBtnLoading] = useState(false);
    const [outletId, setOutletId] = useState('');
    const [editedData, setEditedData] = useState({});
    const [showBtnLoading, setShowBtnLoading] = useState(false);
    const [openViewModal, setOpenViewModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [outletDetails, setOutletDetails] = useState({});
    const [editedOutletImage, setEditedOutletImage] = useState(false);
    const [editValidationErrors, setEditValidationErrors] = useState({
        name: "",
        email: "",
        phone: "",
        address: "",
        pincode: "",
        city: "",
        state: "",
        country: "",
    });
    const [categoryId, setCategoryId] = useState('');
    const [searchData, setSearchData] = useState({
        city: "",
        pincode: ""
    });
    const [searchText, setSearchText] = useState('');
    const [center, setCenter] = useState({
        name: "",
        lat: 17.9104,
        lng: 77.5199,
    });
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [groups, setGroups] = useState([]);
    const [purchaseData, setPurchaseData] = useState([]);
    const [foodUnit, setFoodUnit] = useState([]);
    const [beverageUnit, setBeverageUnit] = useState([]);
    const [centralUnit, setCentralUnit] = useState([]);

    const purchaseOptions = purchaseData?.map((pu) => ({
        label: pu?.name,
        value: pu?._id
    }));

    const foodUnitOptions = foodUnit?.map((pu) => ({
        label: pu?.name,
        value: pu?._id
    }));

    const beverageUnitOptions = beverageUnit?.map((pu) => ({
        label: pu?.name,
        value: pu?._id
    }));

    const centralUnitOptions = centralUnit?.map((pu) => ({
        label: pu?.name,
        value: pu?._id
    }));

    const containerStyle = {
        width: '80%',
        height: '350px',
        margin: '20px auto'
    };

    const updateCenter = (newLat, newLng) => {
        if (typeof newLat === 'number' && typeof newLng === 'number') {
            setCenter({
                lat: newLat,
                lng: newLng,
            });
        } else {
            console.error('Invalid latitude or longitude:', newLat, newLng);
        }
    };

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: 'AIzaSyATjJP7Zx7lNzU-dRY9dLNTY29TfUHXPJo'
    })

    const [map, setMap] = React.useState(null)

    const onLoad = React.useCallback(function callback(map) {
        const bounds = new window.google.maps.LatLngBounds(center);
        map.fitBounds(bounds);
        setMap(map)
    }, [center.lat, center.lng])

    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, [])

    const formatTime = (time) => {
        if (!time) return '';

        let [hours, minutes] = time.split(':');
        hours = parseInt(hours, 10);
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12; // Convert to 12-hour format
        minutes = minutes?.padStart(2, '0'); // Ensure minutes are always two digits

        return `${hours}:${minutes} ${ampm}`;
    };

    const columns = [
        { header: "Sr.No", accessor: "serialNumber" },
        {
            header: "Outlet Name",
            accessor: "name",
            render: (value, row) => (
                <div className="d-flex align-items-center gap-2">
                    <div className="avatar">
                        <img src={row.outletImage} alt="Outlet" />
                    </div>
                    <div>
                        <h6 className="mb-0">{value}</h6>
                        <span className="fs-xs text-secondary">{row.email}</span>
                        <span
                            className={`badge ${row.type === "COMPANY_OWNED"
                                ? "bg-primary"
                                : row.type === "FRANCHISE"
                                    ? "bg-success"
                                    : row.type === "EVENT"
                                        ? "bg-warning text-dark"
                                        : "bg-secondary"
                                }`}
                        >
                            {row.type}
                        </span>
                    </div>
                </div>
            ),
        },
        {
            header: "Menu Group", accessor: "menuGroup",
            render: (value, row) => (
                <div>
                    <span style={{ fontSize: '12px' }} className={row?.menuGroup ? 'text-success' : 'text-danger'}>{row?.menuGroup ? row?.menuGroup?.groupName : "No Menu Allocated"}</span>
                </div>
            )
        },
        {
            header: "Contact", accessor: "phone",
            render: (value, row) => (
                <div>
                    <span className='text-primary'>{value}</span>
                </div>
            )
        },
        {
            header: "City",
            accessor: "city",
            render: (value, row) => (
                <div>
                    <h6 className="mb-0">{value}</h6>
                    <span className="fs-xs text-secondary">{row.pincode}</span>
                </div>
            ),
        },
        {
            header: "State & Country",
            accessor: "state",
            render: (value, row) => (
                <div>
                    <h6 className="mb-0">{value}</h6>
                    <span className="fs-xs text-secondary">{row.country}</span>
                </div>
            ),
        },
        {
            header: "Status & Order Type",
            accessor: "status",
            render: (value, row) => (
                <>
                    <span
                        style={{
                            justifyContent: 'center',
                            display: 'flex',
                            color: row?.orderAcceptType === "PICKUP" ? 'blueviolet'
                                : row?.orderAcceptType === "DELIVERY" ? 'brown'
                                    : 'darkmagenta'
                        }}
                        className="mb-0 pb-0"
                    >
                        {row?.orderAcceptType}
                    </span>
                    {/* <br className="mt-0" /> */}
                    <span
                        className={`badge ${value === "ACTIVE"
                            ? "bg-success"
                            : value === "COMING_SOON"
                                ? "bg-warning"
                                : "bg-danger"
                            }`}
                    >
                        {value}
                    </span>
                </>
            ),
        },
        {
            header: "Actions",
            accessor: null,
            render: (_, row) => (
                <div className="d-flex justify-content-center">
                    <Dropdown>
                        <Dropdown.Toggle variant="link" className="p-0 m-0 border-0">
                            <i className="ri-more-2-fill" style={{ cursor: "pointer" }}></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu align="end">
                            {(outletAccess?.includes("Outlet:update") || email === 'contact@xpansecafe.com') && (
                                <Dropdown.Item
                                    className="text-primary"
                                    onClick={() => handleEditModal(row)}
                                >
                                    Edit
                                </Dropdown.Item>
                            )}
                            {(outletAccess?.includes("Outlet:get") || email === 'contact@xpansecafe.com') && (
                                <Dropdown.Item
                                    className="text-success"
                                    onClick={() => handleOpenViewModal(row)}
                                >
                                    View
                                </Dropdown.Item>
                            )}
                            {(outletAccess?.includes("Outlet:delete") || email === 'contact@xpansecafe.com') && (
                                <Dropdown.Item
                                    className="text-danger"
                                    onClick={() => handleDeleteModal(row)}
                                >
                                    Delete
                                </Dropdown.Item>
                            )}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            ),
        },
    ];

    const getOutlets = async () => {
        setDataLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("outlet", { headers });

            if (response?.data?.status === true) {
                response?.data?.data?.outlets.forEach((item, index) => {
                    item.serialNumber = index + 1;
                });

                setOutlets(response?.data?.data?.outlets);
                setFilteredData(response?.data?.data?.outlets);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setDataLoading(false);
        }
    };

    const getMenuGroup = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("menu-group", { headers });
            if (response?.data?.status === true) {
                setGroups(response?.data?.data?.menuGroup);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const getPostalCodeDetails = async () => {
        try {
            const response = await axios.get(
                `https://api.postalpincode.in/pincode/${inputData.pincode}`
            );

            if (response?.data[0]?.Status === "Success") {
                const postOffice = response?.data[0]?.PostOffice[0];
                setInputData((prevData) => ({
                    ...prevData,
                    city: postOffice?.Division || "",
                    state: postOffice?.State || "",
                    country: postOffice?.Country || "",
                }));
            } else if (response?.data[0]?.Status === "Error") {
                toast.error(`${response?.data[0]?.Message} or Invalid Pincode.`, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                setInputData((prevData) => ({
                    ...prevData,
                    city: "",
                    state: "",
                    country: "",
                }));
            }
        } catch (error) {
            if (error) {
                let errorMessage = error.message;

                if (errorMessage === "Network Error") {
                    toast.error("Invalid Pincode.", {
                        position: "top-right",
                        autoClose: 3000,
                        theme: "colored",
                    });
                }
            }

        }
    };

    const getSingleOutletDetails = async (outletId) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get(`outlet?_id=${outletId}`, { headers });

            if (response?.data?.status === true) {
                setOutletDetails(response?.data?.data?.outlets);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const getProcurementUnits = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }

            const response = await axios.get(`procurement-units/list?page=1&limit=500`, { headers });
            console.log("Response :", response);
            setPurchaseData(response?.data?.data?.procurementUnits);
            let foodU = response?.data?.data?.procurementUnits.filter((fu) => (fu?.type === 'FOOD'))
            let beverageU = response?.data?.data?.procurementUnits.filter((fu) => (fu?.type === 'BEVERAGE'))
            let centralU = response?.data?.data?.procurementUnits.filter((fu) => (fu?.type === 'CENTRAL'))

            setFoodUnit(foodU);
            setBeverageUnit(beverageU);
            setCentralUnit(centralU);
        } catch (error) {
            console.log("Error in fetching purchase unit list :", error);
        }
    }

    const handleOpenImageChangeModal = (id) => {
        setOpenImageModal(false)
        setOpenUpdateImageModal(true);
        setOutletImageId(id);
    }

    const handleOpenAddModal = () => {
        setOpenAddModal(true);
    };

    const handleCloseAddModal = () => {
        setOpenAddModal(false);
        setInputData({
            name: "",
            phone: "",
            email: "",
            address: "",
            pincode: "",
            city: "",
            state: "",
            country: "",
            latitude: "",
            type: "",
            longitude: "",
            isEventOutlet: false,
            openingTime: '',
            orderAcceptType: "",
            closingTime: '',
            gstin: '',
            paymentType: "",
            minimumDeliveryRadius: "",
            menuGroup: "",
            fssai: "",
            foodUnitId: "",
            beverageUnitId: "",
            centralUnitId: "",
            pineLabCredentials: {
                merchantId: "",
                securityToken: "",
                clientId: "",
                storeId: ""
            },
            platForms: [{ name: "", webLink: "" }]
        })
    };

    const handleChange = (e, index) => {
        const { name, value } = e.target;

        if (index !== undefined) {
            // Handle changes for array fields (e.g., platForms)
            setInputData((prevState) => {
                const updatedPlatforms = [...prevState.platForms];
                updatedPlatforms[index] = { ...updatedPlatforms[index], [name]: value };
                return { ...prevState, platForms: updatedPlatforms };
            });
        } else {
            // Handle changes for nested objects (e.g., pineLabCredentials.merchantId)
            if (name.includes(".")) {
                const [parentKey, childKey] = name.split("."); // Split the nested key
                setInputData((prevState) => ({
                    ...prevState,
                    [parentKey]: {
                        ...prevState[parentKey],
                        [childKey]: value,
                    },
                }));
            } else {
                // Handle changes for top-level fields
                setInputData((prevState) => ({
                    ...prevState,
                    [name]: value,
                    ...(name === "pincode" && value === "" ? { city: "", state: "", country: "" } : {}),
                }));
            }
        }

        // Clear validation errors for the field
        // setValidationErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    };

    // Handler function for unit selection changes
    const handleUnitChange = (fieldName, selectedOption) => {
        console.log("Selected options of unit :", selectedOption);
        
        setInputData(prev => ({
            ...prev,
            [fieldName]: selectedOption ? selectedOption.value : ''
        }));
    };

    const handleEditUnitChange = (fieldName, selectedOption) => {
        setEditedData(prev => ({
            ...prev,
            [fieldName]: selectedOption ? selectedOption.value : ''
        }));
    }

    const handleImageChange = (e) => {
        const input = document.getElementById("imageInput");

        const file = input?.files[0];

        if (file) {
            const reader = new FileReader();

            reader.onloadend = () => {
                const image = new Image();
                image.src = reader.result;

                image.onload = () => {
                    const width = image.width;
                    const height = image.height;

                    const maxWidth = 1410;
                    const maxHeight = 1100;

                    if (width === maxWidth && height === maxHeight) {
                        setOutletImage(file);
                    } else {
                        alert(
                            "Image dimensions are not valid. Please choose an image with dimensions equal to " +
                            maxWidth +
                            "x" +
                            maxHeight
                        );
                        input.value = "";
                    }
                };
            };

            reader.readAsDataURL(file);
        }
    };

    const handleAddItem = () => {
        setInputData((prevData) => ({
            ...prevData,
            platForms: [...prevData.platForms, { name: "", webLink: "" }],
        }));
    };

    const handleRemoveItem = (index) => {
        setInputData((prevData) => {
            const updatedItems = [...prevData.platForms];
            updatedItems.splice(index, 1);
            return {
                ...prevData,
                platForms: updatedItems,
            };
        });
    };

    const handleIsEventOutletChange = (e) => {
        setInputData((prev) => ({ ...prev, isEventOutlet: e.target.checked }));
    };

    const addOutlet = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const formData = new FormData();
            formData.append("name", inputData.name);
            formData.append("phone", inputData.phone);
            formData.append("email", inputData.email);
            formData.append("address", inputData.address);
            formData.append("pincode", inputData.pincode);
            formData.append("city", inputData.city);
            formData.append("state", inputData.state);
            formData.append("country", inputData.country);
            formData.append("orderAcceptType", inputData.orderAcceptType);
            formData.append("outletImage", outletImage);
            formData.append("coordinates[latitude]", inputData.latitude);
            formData.append("coordinates[longitude]", inputData.longitude);
            formData.append("gstin", inputData.gstin);
            formData.append("fssai", inputData.fssai);
            if(inputData.foodUnitId) {
                formData.append("foodUnitId", inputData.foodUnitId);
            }
            if (inputData.beverageUnitId) {
                formData.append("beverageUnitId", inputData.beverageUnitId);            
            }
            if (inputData.centralUnitId) {
                formData.append("centralUnitId", inputData.centralUnitId);                
            }
            formData.append("menuGroup", inputData.menuGroup);
            formData.append("type", inputData.type);
            if (inputData.minimumDeliveryRadius) {
                formData.append("minimumDeliveryRadius", inputData.minimumDeliveryRadius);
            }

            formData.append("openingTime", inputData.openingTime || null);
            formData.append("closingTime", inputData.closingTime || null);
            formData.append("isEventOutlet", inputData.isEventOutlet || false);
            formData.append("paymentType", inputData.paymentType);

            if (inputData.paymentType === "CARD_SWIPE") {
                formData.append("pineLabCredentials[merchantId]", inputData.pineLabCredentials.merchantId);
                formData.append("pineLabCredentials[securityToken]", inputData.pineLabCredentials.securityToken);
                formData.append("pineLabCredentials[clientId]", inputData.pineLabCredentials.clientId);
                formData.append("pineLabCredentials[storeId]", inputData.pineLabCredentials.storeId);
            }

            inputData.platForms.forEach((platform, index) => {
                // formData.append(`platForms[${index}][name]`, platform.name);
                // formData.append(`platForms[${index}][webLink]`, platform.webLink);
                if (platform.name && platform.webLink) {
                    formData.append(`platForms[${index}][name]`, platform.name);
                    formData.append(`platForms[${index}][webLink]`, platform.webLink);
                }
            });

            const headers = {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${accessToken}`,
            };

            const response = await axios.post("outlet", formData, { headers });

            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                getOutlets();

                e.target.reset();
                setInputData({
                    name: "",
                    email: "",
                    phone: "",
                    address: "",
                    pincode: "",
                    city: "",
                    state: "",
                    country: "",
                    latitude: "",
                    longitude: "",
                    fssai: "",
                    status: "",
                    orderAcceptType: "",
                    minimumDeliveryRadius: "",
                    menuGroup: "",
                    type: "",
                    closingTime:"",
                    gstin: "",
                    isEventOutlet: false,
                    openingTime: "",
                    paymentType: "",
                    pineLabCredentials: "", 
                    foodUnitId: "",
                    beverageUnitId: "",
                    centralUnitId: "",
                    platForms: [{ name: "", webLink: "" }],
                });
                setOpenAddModal(false);
            }
        } catch (error) {
            console.log("Error Outlet :", error);

            if (error?.response) {
                let errorMessage = '';
                if (error.response?.status === 406) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                }
                else if (error.response?.status === 404) {
                    errorMessage = error?.response?.data?.error;
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleEditModal = async (data) => {
        console.log("Edited Data :", data);

        setEditedData({
            _id: data?._id,
            name: data.name,
            email: data.email,
            phone: data.phone,
            address: data.address,
            pincode: data.pincode,
            city: data.city,
            state: data.state,
            gstin: data.gstin,
            country: data.country,
            type: data.type,
            latitude: data?.coordinates?.latitude,
            longitude: data?.coordinates?.longitude,
            openingTime: data?.openingTime,
            closingTime: data?.closingTime,
            status: data?.status,
            fssai: data?.fssai,
            minimumDeliveryRadius: data?.minimumDeliveryRadius,
            orderAcceptType: data?.orderAcceptType,
            isEventOutlet: data?.isEventOutlet,
            isOutletClosed: data?.isOutletClosed,
            menuGroup: data?.menuGroup?._id,
            paymentType: data?.paymentType,
            foodUnitId: data?.foodUnitId,
            beverageUnitId: data?.beverageUnitId,
            centralUnitId: data?.centralUnitId,
            pineLabCredentials: {
                clientId: data?.pineLabCredentials?.clientId,
                merchantId: data?.pineLabCredentials?.merchantId,
                securityToken: data?.pineLabCredentials?.securityToken,
                storeId: data?.pineLabCredentials?.storeId,
            },
            platForms: Array.isArray(data.platForms) ? data.platForms : [],
        });

        setOutletId(data._id);
        setOpenEditModal(true);
    };

    const handleEditChange = (e, platformIndex = null) => {
        const { name, value } = e.target;

        if (platformIndex !== null) {
            // Handle platform-specific fields (e.g., platformName, platformWeblink)
            setEditedData((prevState) => {
                const updatedPlatforms = [...prevState.platForms];

                // Initialize the platform object if it doesn't exist
                if (!updatedPlatforms[platformIndex]) {
                    updatedPlatforms[platformIndex] = { name: '', webLink: '' };
                }

                // Update the specific platform field
                if (name === "platformName" || name === "platformWeblink") {
                    updatedPlatforms[platformIndex][name === "platformName" ? "name" : "webLink"] = value;
                }

                return {
                    ...prevState,
                    platForms: updatedPlatforms,
                };
            });
        } else if (name.includes(".")) {
            // Handle nested objects (e.g., pineLabCredentials.merchantId)
            const [parentKey, childKey] = name.split("."); // Split the nested key
            setEditedData((prevState) => ({
                ...prevState,
                [parentKey]: {
                    ...prevState[parentKey],
                    [childKey]: value,
                },
            }));
        } else {
            // Handle regular fields (e.g., pincode, city, state, country)
            setEditedData((prevState) => ({
                ...prevState,
                [name]: value,
                ...(name === "pincode" && value === "" ? { city: "", state: "", country: "" } : {}),
            }));
        }

        // Reset validation errors for the field
        setEditValidationErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "",
        }));
    };

    const handleIsOutletClosedChange = (e) => {
        setEditedData((prev) => ({ ...prev, isOutletClosed: e.target.checked }))
    }

    const handleAddEditItem = () => {
        setEditedData((prevData) => ({
            ...prevData,
            platForms: [
                ...prevData.platForms,
                { name: "", webLink: "" },
            ],
        }));
    };

    const handleRemoveEditItem = (index) => {
        setEditedData((prevData) => {
            const updatedItems = [...prevData.platForms];
            updatedItems.splice(index, 1);
            return {
                ...prevData,
                platForms: updatedItems,
            };
        });
    };

    const handleEditIsEventOutletChange = (e) => {
        setEditedData((prev) => ({ ...prev, isEventOutlet: e.target.checked }))
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        setIsEditBtnLoading(true);
        try {
            const formData = new FormData();
            formData.append("_id", editedData._id);
            formData.append("name", editedData.name);
            formData.append("phone", editedData.phone);
            formData.append("email", editedData.email);
            formData.append("address", editedData.address);
            formData.append("pincode", editedData.pincode);
            formData.append("city", editedData.city);
            formData.append("state", editedData.state);
            formData.append("country", editedData.country);
            formData.append("type", editedData.type);
            formData.append("orderAcceptType", editedData.orderAcceptType);
            formData.append("coordinates[latitude]", editedData.latitude);
            formData.append("coordinates[longitude]", editedData.longitude);
            formData.append("isOutletClosed", editedData.isOutletClosed);
            formData.append("status", editedData?.status);
            formData.append("isEventOutlet", editedData?.isEventOutlet);
            formData.append("gstin", editedData?.gstin);
            formData.append("menuGroup", editedData?.menuGroup);
            formData.append("fssai", editedData?.fssai);
            formData.append("foodUnitId", editedData?.foodUnitId || "");
            formData.append("beverageUnitId", editedData?.beverageUnitId || "");
            formData.append("centralUnitId", editedData?.centralUnitId || "");
            formData.append("openingTime", editedData?.openingTime || null);
            formData.append("closingTime", editedData?.closingTime || null);
            formData.append("paymentType", editedData.paymentType);
            if (editedData.minimumDeliveryRadius) {
                formData.append("minimumDeliveryRadius", editedData.minimumDeliveryRadius);
            }

            if (editedData.paymentType === "CARD_SWIPE") {
                formData.append("pineLabCredentials[merchantId]", editedData.pineLabCredentials.merchantId);
                formData.append("pineLabCredentials[securityToken]", editedData.pineLabCredentials.securityToken);
                formData.append("pineLabCredentials[clientId]", editedData.pineLabCredentials.clientId);
                formData.append("pineLabCredentials[storeId]", editedData.pineLabCredentials.storeId);
            }
            if (editedData?.platForms.length > 0) {
                editedData.platForms.forEach((platform, index) => {
                    // Check if both fields (name and webLink) are not empty or just whitespace
                    if (platform.name.trim() !== '' && platform.webLink.trim() !== '') {
                        formData.append(`platForms[${index}][name]`, platform.name);
                        formData.append(`platForms[${index}][webLink]`, platform.webLink);

                        // Append _id if it exists
                        if (platform._id) {
                            formData.append(`platForms[${index}][_id]`, platform._id);
                        }
                    }
                });
            }

            const headers = {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${accessToken}`,
            };

            console.log("Form Data :", formData);
            

            const response = await axios.put("outlet", formData, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                getOutlets();
                setOpenEditModal(false);
                getSingleOutletDetails(outletId);
                setOpenViewModal(true);
                setOutletId("");
            }
        } catch (error) {
            console.log("Error in Updating :", error);
            
            if (error?.response) {
                let errorMessage = '';
                if ( error.response?.status === 406 ) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                } else if ( error.response?.status === 404 ) {
                    errorMessage = error?.response?.data?.error;
                }
                else if ( error.response?.status === 412 ) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        } finally {
            setIsEditBtnLoading(false);
        }
    };

    const handleDeleteModal = async (data) => {
        setOpenDeleteModal(true);
        setCategoryId(data?._id);
    };

    const deleteOutlet = async (e) => {
        e.preventDefault();
        setIsDeleteLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const data = {
                _id: categoryId,
            };
            const response = await axios.delete(`outlet`, { data, headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                getOutlets();
                setOpenDeleteModal(false);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsDeleteLoading(false);
        }
    };

    const handleCloseDeleteModal = () => {
        setOpenDeleteModal(false);
    };

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setSearchData((prev) => ({ ...prev, [name]: value }))
    };

    const handleOpenViewModal = (data) => {
        const newLat = parseFloat(data?.coordinates?.latitude);
        const newLng = parseFloat(data?.coordinates?.longitude);
        if (!isNaN(newLat) && !isNaN(newLng)) {
            updateCenter(newLat, newLng);
            setCenter((prev) => ({ ...prev, name: data.name }))
            setOpenViewModal(true);
            getSingleOutletDetails(data?._id);
        } else {
            console.error('Invalid coordinates:', data?.coordinates);
        }
    }

    const handleFilterSubmit = async (e) => {
        setShowBtnLoading(true);
        setDataLoading(true);
        e.preventDefault();
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const response = await axios.get(`outlet/getOutletCityPincode?city=${searchData?.city}&pincode=${searchData?.pincode}`, { headers });
            if (response?.data?.status === true) {
                const totalRecords = response?.data?.data?.totalOutletRecords;
                setFilteredData(totalRecords)
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });

            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (
                    error.response?.status === 406
                ) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                }
                else if (
                    error.response?.status === 412
                ) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setShowBtnLoading(false);
            setDataLoading(false);
        }
    };

    const handleEditImageChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            const reader = new FileReader();

            reader.onloadend = () => {
                const image = new Image();
                image.src = reader.result;

                image.onload = () => {
                    const width = image.width;
                    const height = image.height;
                    const maxWidth = 1410;
                    const maxHeight = 1100;

                    if (width === maxWidth && height === maxHeight) {
                        // Set the selected file to editedOutletImage if dimensions are correct
                        setEditedOutletImage(file);
                    } else {
                        alert(
                            `Invalid image dimensions. Please upload an image with dimensions ${maxWidth}x${maxHeight}.`
                        );
                        e.target.value = ""; // Clear the file input if dimensions are incorrect
                    }
                };
            };

            reader.readAsDataURL(file);
        }
    };

    const handleUpdateImage = async (e) => {
        e.preventDefault();
        setIsUpdateImageBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }
            const formData = new FormData();
            formData.append('outletImage', editedOutletImage);
            formData.append('_id', outletImageId);
            const response = await axios.put("outlet", formData, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                getOutlets();
                setOpenUpdateImageModal(false);
                setOpenViewModal(false);
            }

        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (
                    error.response?.status === 406
                ) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                }
                else if (
                    error.response?.status === 412
                ) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsUpdateImageBtnLoading(false);
        }
    };

    const handlePageChange = (page) => {
        setPage(page);
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        setPage(1);
        setRowsPerPage(rowsPerPage);
    };

    const getPaginatedData = () => {
        const startIndex = (page - 1) * rowsPerPage;

        const endIndex = startIndex + rowsPerPage;

        return filteredData?.slice(startIndex, endIndex);
    };

    const getEditPostalCodeDetails = async () => {
        try {
            const response = await axios.get(
                `https://api.postalpincode.in/pincode/${editedData.pincode}`
            );

            if (response?.data[0]?.Status === "Success") {
                const postOffice = response?.data[0]?.PostOffice[0];
                setEditedData((prevData) => ({
                    ...prevData,
                    city: postOffice?.Division || "",
                    state: postOffice?.State || "",
                    country: postOffice?.Country || "",
                }));
            } else if (response?.data[0]?.Status === "Error") {
                toast.error(`${response?.data[0]?.Message} or Invalid Pincode.`, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                setEditedData((prevData) => ({
                    ...prevData,
                    city: "",
                    state: "",
                    country: "",
                }));
            }
        } catch (error) {
            toast.error(error.message, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });
        }
    };

    useEffect(() => {
        const result = outlets.filter((item) => {
            return (
                item.name.toLowerCase().match(searchText.toLocaleLowerCase()) ||
                item.email.toLowerCase().match(searchText.toLocaleLowerCase()) ||
                item.phone.toLowerCase().match(searchText.toLocaleLowerCase()) ||
                item.address.toLowerCase().match(searchText.toLocaleLowerCase()) ||
                item.pincode.toLowerCase().match(searchText.toLocaleLowerCase()) ||
                item.city.toLowerCase().match(searchText.toLocaleLowerCase()) ||
                item.state.toLowerCase().match(searchText.toLocaleLowerCase()) ||
                item.country.toLowerCase().match(searchText.toLocaleLowerCase())
            );
        });
        setFilteredData(result);
    }, [searchText]);

    useEffect(() => {
        if (searchData?.city === "" && searchData?.pincode === "") {
            getOutlets();
        }
    }, [searchData?.city, searchData?.pincode]);

    useEffect(() => {
        getOutlets();
        getMenuGroup();
        getProcurementUnits();
    }, []);

    useEffect(() => {
        if (inputData.paymentType === "PAYMENT_GATEWAY") {
            setInputData((prev) => ({
                ...prev,
                pineLabCredentials: {
                    merchantId: "",
                    clientId: "",
                    securityToken: "",
                    storeId: ""
                }
            }));
        }
    }, [inputData.paymentType]);


    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
                <div
                    className="container shadow-sm"
                    style={{ backgroundColor: "white" }}
                >
                    <Row className="pt-4">
                        <Col>
                            <h5 className="fw-semibold">OUTLET MANAGEMENT</h5>
                        </Col>
                        <hr />
                    </Row>
                    <Row className="mb-3">
                        <Col lg="2">
                            <Form.Label className="fw-semibold">City</Form.Label>
                            <Form.Control placeholder="Enter City" type="text" name="city" onChange={handleFilterChange} value={searchData.city} />
                        </Col>
                        <Col lg="2">
                            <Form.Label className="fw-semibold">Pincode</Form.Label>
                            <Form.Control placeholder="Enter Pincode" type="text" name="pincode" onChange={handleFilterChange} value={searchData.pincode} />
                        </Col>
                        <Col lg="2" className="d-flex justify-content-end flex-column">
                            {/* <Form.Label className="text-white">.</Form.Label> */}
                            <Button variant="success" className="fw-semibold" disabled={!(searchData.pincode && searchData.city)} onClick={handleFilterSubmit}>
                                {showBtnLoading ? <Spinner size="sm" /> : "Show"}
                            </Button>
                        </Col>
                        <Col>
                            <div>
                                <Form.Label className="text-white">.</Form.Label>
                            </div>
                            <div className="input-group w-100">
                                <input
                                    type="text"
                                    value={searchText}
                                    onChange={handleSearchChange}
                                    className="form-control"
                                    placeholder="Search for outlets..."
                                />
                                <button className="btn btn-primary" type="button">
                                    <i className="ri-search-line"></i>
                                </button>
                            </div>
                        </Col>
                        <Col lg="2" className="d-flex justify-content-end flex-column">
                            <Form.Label className="text-white">.</Form.Label>
                            <Button
                                variant="primary"
                                className="fw-semibold"
                                onClick={handleOpenAddModal}
                            >
                                <i className="ri-add-line" style={{ marginRight: "5px" }}></i>
                                Add New Outlet
                            </Button>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            {(outletAccess?.includes("Outlet:get") || email === 'contact@xpansecafe.com') && (
                                <ReusableTable
                                    columns={columns}
                                    data={getPaginatedData()}
                                    rowKey="serialNumber"
                                    loading={dataLoading}
                                    currentPage={page}
                                    recordsPerPage={rowsPerPage}
                                    onPageChange={handlePageChange}
                                    totalPages={Math.ceil(filteredData.length / rowsPerPage)}
                                    onRecordsPerPageChange={handleRowsPerPageChange}
                                />
                            )}
                        </Col>
                    </Row>

                    {/* <------------- Add Outlets Modal ---------------> */}
                    {/* {openAddModal ? (
                        <Modal   l
                            size="xl"
                            centered
                            show={openAddModal}
                            onHide={handleCloseAddModal}
                            aria-labelledby="VerticallyCenteredExample"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title>ADD OUTLET</Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={addOutlet}>
                                <Modal.Body>
                                <Row>
                                    <Col md="6" lg="4">
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Name <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Name"
                                                name="name"
                                                value={inputData.name}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md="6" lg="4">
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">
                                            Email <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="email"
                                                placeholder="Email"
                                                name="email"
                                                value={inputData.email}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md="6" lg="4">
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Phone <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                minLength={10}
                                                type="number"
                                                placeholder="Phone/Mobile"
                                                className="no-arrows"
                                                name="phone"
                                                value={inputData.phone}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md="6" lg="4">
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Select Menu Group <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select
                                                id="selectField"
                                                name="menuGroup"
                                                value={inputData.menuGroup}
                                                onChange={handleChange}
                                            >
                                            <option value="">Select Menu Group</option>
                                            {groups.map(group => (
                                                <option key={group._id} value={group._id}>{group.groupName}</option>
                                            ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md="6" lg="4">
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">
                                            Choose Outlet Image <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                id="imageInput"
                                                accept="image/*"
                                                type="file"
                                                onChange={handleImageChange}
                                            />
                                            <span className="text-success" style={{ fontSize: '12px' }}>
                                            Choose an image with dimensions 1410x1100
                                            </span>
                                        </Form.Group>
                                    </Col>

                                    <Col md="6" lg="4">
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                ACCEPT ORDER IN <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select
                                                id="selectField"
                                                name="orderAcceptType"
                                                value={inputData.orderAcceptType}
                                                onChange={handleChange}
                                            >
                                                <option value="">Select Order Type</option>
                                                <option value="ALL">ALL</option>
                                                <option value="PICKUP">PICKUP</option>
                                                <option value="DELIVERY">DELIVERY</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md="6" lg="3">
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">GSTIN <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="GstIn"
                                                name="gstin"
                                                value={inputData.gstin}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md="6" lg="3">
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">FSSAI</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="FSSAI"
                                                name="fssai"
                                                value={inputData.fssai}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md="6" lg="2">
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Select Outlet Type <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select
                                                id="selectField"
                                                name="type"
                                                value={inputData.type}
                                                onChange={handleChange}
                                            >
                                                <option value="">Select Type</option>
                                                <option value="COMPANY_OWNED">COMPANY OWNED</option>
                                                <option value="FRANCHISE">FRANCHISE OUTLET</option>
                                                <option value="EVENT">EVENT OUTELT</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>                                    

                                    <Col md="2" lg="1">
                                        <Form.Label className="fw-semibold">
                                            Is It Event Outlet? <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Check
                                            type="switch"
                                            id="formSwitchCheckDefault"
                                            onChange={handleIsEventOutletChange}
                                            checked={inputData?.isEventOutlet}
                                        />
                                    </Col>

                                    <Col md="2" lg="3">
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Delivery Radius (In Kms) <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                min={0}
                                                type="number"
                                                placeholder="Enter Minimum Delivery Radius (Kms)"
                                                className="no-arrows"
                                                name="minimumDeliveryRadius"
                                                value={inputData.minimumDeliveryRadius}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md="6" lg="6">
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Address <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={2}
                                                placeholder="Address"
                                                name="address"
                                                value={inputData.address}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md="3" lg="3">
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Latitude <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="number"
                                                placeholder="Latitude"
                                                className="no-arrows"
                                                name="latitude"
                                                value={inputData.latitude}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md="3" lg="3">
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">
                                            Longitude <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                            type="number"
                                            placeholder="Longitude"
                                            className="no-arrows"
                                            name="longitude"
                                            value={inputData.longitude}
                                            onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md="2" lg="2">
                                    <Form.Group className="mb-3">
                                        <Form.Label className="fw-semibold">Opening Time</Form.Label>
                                        <Form.Control
                                        type="time"
                                        placeholder="Opening Time"
                                        name="openingTime"
                                        value={inputData.openingTime}
                                        onChange={handleChange}
                                        />
                                    </Form.Group>
                                    </Col>
                                    <Col md="2" lg="2">
                                    <Form.Group className="mb-3">
                                        <Form.Label className="fw-semibold">Closing Time</Form.Label>
                                        <Form.Control
                                        type="time"
                                        placeholder="Closing Time"
                                        name="closingTime"
                                        value={inputData.closingTime}
                                        onChange={handleChange}
                                        />
                                    </Form.Group>
                                    </Col>
                                    <Col md="2" lg="2">
                                    <Form.Group className="mb-3">
                                        <Form.Label className="fw-semibold">
                                        Pincode <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                        minLength={6}
                                        type="number"
                                        placeholder="Pincode"
                                        className="no-arrows"
                                        name="pincode"
                                        value={inputData.pincode}
                                        onChange={handleChange}
                                        onBlur={getPostalCodeDetails}
                                        />
                                    </Form.Group>
                                    </Col>
                                    <Col md="2" lg="2">
                                    <Form.Group className="mb-3">
                                        <Form.Label className="fw-semibold">
                                        City <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                        type="text"
                                        placeholder="City"
                                        name="city"
                                        value={inputData.city}
                                        onChange={handleChange}
                                        />
                                    </Form.Group>
                                    </Col>
                                    <Col md="2" lg="2">
                                    <Form.Group className="mb-3">
                                        <Form.Label className="fw-semibold">
                                        State <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                        type="text"
                                        placeholder="State"
                                        name="state"
                                        value={inputData.state}
                                        onChange={handleChange}
                                        />
                                    </Form.Group>
                                    </Col>
                                    <Col md="2" lg="2">
                                    <Form.Group className="mb-3">
                                        <Form.Label className="fw-semibold">
                                        Country <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                        type="text"
                                        placeholder="Country"
                                        name="country"
                                        value={inputData.country}
                                        onChange={handleChange}
                                        />
                                    </Form.Group>
                                    </Col>
                                </Row>

                                <h6>ADD PAYMENT METHOD</h6>
                                <hr className="mt-0" />

                                <Row className="mb-2">
                                    <Col md="3" lg="3">
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">
                                            Select Payment Method <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select
                                                id="selectField"
                                                name="paymentType"
                                                value={inputData.paymentType}
                                                onChange={handleChange}
                                            >
                                            <option value="">Select Method</option>
                                            <option value="PAYMENT_GATEWAY">RAZOR PAY</option>
                                            <option value="CARD_SWIPE">PINE LABS MACHINE</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    {inputData.paymentType === "CARD_SWIPE" && (
                                        <>
                                            <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">Merchant ID <span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Merchant ID"
                                                    name="pineLabCredentials.merchantId"
                                                    value={inputData?.pineLabCredentials?.merchantId}
                                                    onChange={handleChange}
                                                />
                                            </Form.Group>
                                            </Col>
                                            <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">Security Token <span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Security Token"
                                                    name="pineLabCredentials.securityToken"
                                                    value={inputData?.pineLabCredentials?.securityToken}
                                                    onChange={handleChange}
                                                />
                                            </Form.Group>
                                            </Col>
                                            <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">Client ID <span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Client ID"
                                                    name="pineLabCredentials.clientId"
                                                    value={inputData?.pineLabCredentials?.clientId}
                                                    onChange={handleChange}
                                                />
                                            </Form.Group>
                                            </Col>
                                        </>
                                    )}
                                </Row>

                                {inputData?.paymentType === "CARD_SWIPE" && (
                                    <Row className="mb-3">
                                    <Col md="3" lg="3">
                                        <Form.Group className="mb-3">
                                        <Form.Label className="fw-semibold">Store ID <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Client ID"
                                            name="pineLabCredentials.storeId"
                                            value={inputData?.pineLabCredentials?.storeId}
                                            onChange={handleChange}
                                        />
                                        </Form.Group>
                                    </Col>
                                    </Row>
                                )}

                                <h6>ADD DELIVERY PLATFORMS</h6>
                                <hr className="mt-0" />
                                <Row>
                                    {inputData?.platForms &&
                                    inputData?.platForms?.length > 0 &&
                                    inputData?.platForms?.map((item, index) => (
                                        <div key={index} className="mt-2">
                                        <Row>
                                            <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">Name</Form.Label>
                                                <Form.Control
                                                type="text"
                                                id={`platForms-${index}`}
                                                placeholder="Platform Name"
                                                className="no-arrows"
                                                name="name"
                                                value={item.name}
                                                onChange={(e) => handleChange(e, index)}
                                                />
                                            </Form.Group>
                                            </Col>
                                            <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">Weblink</Form.Label>
                                                <Form.Control
                                                type="text"
                                                id={`platForms-${index}`}
                                                placeholder="Weblink"
                                                className="no-arrows"
                                                name="webLink"
                                                value={item.webLink}
                                                onChange={(e) => handleChange(e, index)}
                                                />
                                            </Form.Group>
                                            </Col>
                                            <Col md="1">
                                            <div className="d-flex justify-content-end mt-2">
                                                {index === inputData.platForms.length - 1 && (
                                                <div>
                                                    <Button
                                                    size="sm"
                                                    onClick={handleAddItem}
                                                    variant="primary"
                                                    style={{
                                                        marginRight: "3px",
                                                        borderRadius: "50%",
                                                    }}
                                                    >
                                                        <i className="ri-add-fill fs-4"></i>
                                                    </Button>
                                                </div>
                                                )}

                                                {inputData.platForms.length > 1 && (
                                                <div>
                                                    <Button
                                                    size="sm"
                                                    onClick={() => handleRemoveItem(index)}
                                                    variant="primary"
                                                    style={{ borderRadius: "18px" }}
                                                    >
                                                        <i className="ri-subtract-fill fs-4"></i>
                                                    </Button>
                                                </div>
                                                )}
                                            </div>
                                            </Col>
                                        </Row>
                                        </div>
                                    ))}
                                </Row>
                                </Modal.Body>
                                <Modal.Footer>
                                <Button type="submit" variant="primary" disabled={isLoading}>
                                    {isLoading ? 'Adding...' : 'ADD OUTLET'}
                                </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    ) : null} */}

                    {openAddModal ? (
                        <Modal
                            size="xl"
                            centered
                            show={openAddModal}
                            onHide={handleCloseAddModal}
                            aria-labelledby="add-outlet-modal"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title>Add New Outlet</Modal.Title>
                            </Modal.Header>

                            <Form onSubmit={addOutlet}>
                                <Modal.Body>
                                    {/* Basic Information Section */}
                                    <div className="mb-4">
                                        <h6 className="fw-semibold text-primary">BASIC INFORMATION</h6>
                                        <hr className="mt-1" />
                                        <Row>
                                            <Col md="6" lg="4">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Outlet Name <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter outlet name"
                                                        name="name"
                                                        value={inputData.name}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md="6" lg="4">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Email <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="email"
                                                        placeholder="email@example.com"
                                                        name="email"
                                                        value={inputData.email}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md="6" lg="4">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Phone <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        minLength={10}
                                                        type="number"
                                                        placeholder="Phone number"
                                                        className="no-arrows"
                                                        name="phone"
                                                        value={inputData.phone}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </div>

                                    {/* Location & Operation Details */}
                                    <div className="mb-4">
                                        <h6 className="fw-semibold text-primary">LOCATION & OPERATION</h6>
                                        <hr className="mt-1" />
                                        <Row>
                                            <Col md="6" lg="4">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Menu Group <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Select
                                                        name="menuGroup"
                                                        value={inputData.menuGroup}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="">Select Menu Group</option>
                                                        {groups.map(group => (
                                                            <option key={group._id} value={group._id}>
                                                                {group.groupName}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>

                                            <Col md="6" lg="4">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Order Acceptance <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Select
                                                        name="orderAcceptType"
                                                        value={inputData.orderAcceptType}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="">Select order type</option>
                                                        <option value="ALL">All Orders</option>
                                                        <option value="PICKUP">Pickup Only</option>
                                                        <option value="DELIVERY">Delivery Only</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>

                                            <Col md="6" lg="4">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Outlet Type <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Select
                                                        name="type"
                                                        value={inputData.type}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="">Select type</option>
                                                        <option value="COMPANY_OWNED">Company Owned</option>
                                                        <option value="FRANCHISE">Franchise Outlet</option>
                                                        <option value="EVENT">Event Outlet</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md="3" lg="2">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Event Outlet? <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <div className="mt-2">
                                                        <Form.Check
                                                            type="switch"
                                                            id="eventOutletSwitch"
                                                            onChange={handleIsEventOutletChange}
                                                            checked={inputData?.isEventOutlet}
                                                            label={inputData?.isEventOutlet ? "Yes" : "No"}
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Col>

                                            <Col md="3" lg="3">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Delivery Radius (km) <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        min={0}
                                                        type="number"
                                                        placeholder="Enter radius in km"
                                                        className="no-arrows"
                                                        name="minimumDeliveryRadius"
                                                        value={inputData.minimumDeliveryRadius}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md="3" lg="2">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">Opening Time</Form.Label>
                                                    <Form.Control
                                                        type="time"
                                                        name="openingTime"
                                                        value={inputData.openingTime}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md="3" lg="2">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">Closing Time</Form.Label>
                                                    <Form.Control
                                                        type="time"
                                                        name="closingTime"
                                                        value={inputData.closingTime}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </div>

                                    {/* Address Information */}
                                    <div className="mb-4">
                                        <h6 className="fw-semibold text-primary">ADDRESS DETAILS</h6>
                                        <hr className="mt-1" />
                                        <Row>
                                            <Col lg="8">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Full Address <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={2}
                                                        placeholder="Enter complete address"
                                                        name="address"
                                                        value={inputData.address}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md="6" lg="3">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Pincode <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        minLength={6}
                                                        type="number"
                                                        placeholder="Pincode"
                                                        className="no-arrows"
                                                        name="pincode"
                                                        value={inputData.pincode}
                                                        onChange={handleChange}
                                                        onBlur={getPostalCodeDetails}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md="6" lg="3">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        City <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="City"
                                                        name="city"
                                                        value={inputData.city}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md="6" lg="3">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        State <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="State"
                                                        name="state"
                                                        value={inputData.state}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md="6" lg="3">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Country <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Country"
                                                        name="country"
                                                        value={inputData.country}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md="6" lg="3">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Latitude <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        placeholder="Latitude"
                                                        className="no-arrows"
                                                        name="latitude"
                                                        value={inputData.latitude}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md="6" lg="3">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Longitude <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        placeholder="Longitude"
                                                        className="no-arrows"
                                                        name="longitude"
                                                        value={inputData.longitude}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </div>

                                    {/* Business & Legal Details */}
                                    <div className="mb-4">
                                        <h6 className="fw-semibold text-primary">BUSINESS & LEGAL</h6>
                                        <hr className="mt-1" />
                                        <Row>
                                            <Col md="6" lg="3">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        GSTIN <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="GSTIN number"
                                                        name="gstin"
                                                        value={inputData.gstin}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md="6" lg="3">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">FSSAI License</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="FSSAI number"
                                                        name="fssai"
                                                        value={inputData.fssai}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md="6" lg="6">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Outlet Image <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        id="imageInput"
                                                        accept="image/*"
                                                        type="file"
                                                        onChange={handleImageChange}
                                                    />
                                                    <Form.Text className="text-muted" style={{ fontSize: '12px' }}>
                                                        Recommended image size: 1410x1100 pixels
                                                    </Form.Text>
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        {/* New Unit Selection Fields */}
                                        <Row>
                                            <Col md="4" lg="4">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Food Unit <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Select
                                                        options={foodUnitOptions} // You'll need to provide this array
                                                        value={foodUnitOptions?.find(option => option.value === inputData.foodUnitId)}
                                                        onChange={(selectedOption) => handleUnitChange('foodUnitId', selectedOption)}
                                                        placeholder="Select Food Unit"
                                                        isSearchable
                                                        components={animatedComponents}
                                                        styles={customSelectStyles}
                                                        isClearable
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md="4" lg="4">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Beverage Unit <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Select
                                                        options={beverageUnitOptions} // You'll need to provide this array
                                                        value={beverageUnitOptions?.find(option => option.value === inputData.beverageUnitId)}
                                                        onChange={(selectedOption) => handleUnitChange('beverageUnitId', selectedOption)}
                                                        placeholder="Select Beverage Unit"
                                                        isSearchable
                                                        components={animatedComponents}
                                                        styles={customSelectStyles}
                                                        isClearable
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md="4" lg="4">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Central Unit <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Select
                                                        options={centralUnitOptions} // You'll need to provide this array
                                                        value={centralUnitOptions?.find(option => option.value === inputData.centralUnitId)}
                                                        onChange={(selectedOption) => handleUnitChange('centralUnitId', selectedOption)}
                                                        placeholder="Select Central Unit"
                                                        isSearchable
                                                        styles={customSelectStyles}
                                                        components={animatedComponents}
                                                        isClearable
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </div>

                                    {/* Payment Method */}
                                    <div className="mb-4">
                                        <h6 className="fw-semibold text-primary">PAYMENT METHOD</h6>
                                        <hr className="mt-1" />
                                        <Row>
                                            <Col md="6" lg="4">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Payment Method <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Select
                                                        name="paymentType"
                                                        value={inputData.paymentType}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="">Select payment method</option>
                                                        <option value="PAYMENT_GATEWAY">Razor Pay</option>
                                                        <option value="CARD_SWIPE">Pine Labs Machine</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        {inputData.paymentType === "CARD_SWIPE" && (
                                            <Row>
                                                <Col md="6" lg="3">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="fw-semibold">
                                                            Merchant ID <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Merchant ID"
                                                            name="pineLabCredentials.merchantId"
                                                            value={inputData?.pineLabCredentials?.merchantId}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col md="6" lg="3">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="fw-semibold">
                                                            Security Token <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Security Token"
                                                            name="pineLabCredentials.securityToken"
                                                            value={inputData?.pineLabCredentials?.securityToken}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col md="6" lg="3">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="fw-semibold">
                                                            Client ID <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Client ID"
                                                            name="pineLabCredentials.clientId"
                                                            value={inputData?.pineLabCredentials?.clientId}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col md="6" lg="3">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="fw-semibold">
                                                            Store ID <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Store ID"
                                                            name="pineLabCredentials.storeId"
                                                            value={inputData?.pineLabCredentials?.storeId}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        )}
                                    </div>

                                    {/* Delivery Platforms */}
                                    <div className="mb-3">
                                        <h6 className="fw-semibold text-primary">DELIVERY PLATFORMS</h6>
                                        <hr className="mt-1" />
                                        {inputData?.platForms?.map((item, index) => (
                                            <div key={index} className="mb-3 p-3 border rounded">
                                                <Row className="align-items-end">
                                                    <Col md="5">
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className="fw-semibold">Platform Name</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Platform name"
                                                                name="name"
                                                                value={item.name}
                                                                onChange={(e) => handleChange(e, index)}
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md="5">
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className="fw-semibold">Website Link</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="https://example.com"
                                                                name="webLink"
                                                                value={item.webLink}
                                                                onChange={(e) => handleChange(e, index)}
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md="2">
                                                        <div className="d-flex gap-2 mb-3">
                                                            {index === inputData.platForms.length - 1 && (
                                                                <Button
                                                                    size="sm"
                                                                    onClick={handleAddItem}
                                                                    variant="outline-success"
                                                                    className="rounded-circle"
                                                                    title="Add platform"
                                                                >
                                                                    <i className="ri-add-line"></i>
                                                                </Button>
                                                            )}

                                                            {inputData.platForms.length > 1 && (
                                                                <Button
                                                                    size="sm"
                                                                    onClick={() => handleRemoveItem(index)}
                                                                    variant="outline-danger"
                                                                    className="rounded-circle"
                                                                    title="Remove platform"
                                                                >
                                                                    <i className="ri-subtract-line"></i>
                                                                </Button>
                                                            )}
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        ))}
                                    </div>
                                </Modal.Body>

                                <Modal.Footer className="border-top pt-3">
                                    <Button
                                        variant="outline-secondary"
                                        onClick={handleCloseAddModal}
                                        className="me-2"
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        type="submit"
                                        variant="primary"
                                        disabled={isLoading}
                                        className="px-4"
                                    >
                                        {isLoading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" />
                                                Adding Outlet...
                                            </>
                                        ) : (
                                            'Add Outlet'
                                        )}
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    ) : null}

                    {/* <------------- Edit Outlets Modal -------------->  */}
                    {/* {openEditModal ? (
                        <Modal
                            size="xl"
                            centered
                            show={openEditModal}
                            onHide={() => setOpenEditModal(false)}
                            aria-labelledby="VerticallyCenteredExample"
                        >
                            <Modal.Header style={{ backgroundColor: "#F5F5F5" }} closeButton>
                                <Modal.Title id="VerticallyCenteredExample" className="fs-4">
                                    EDIT OUTLET
                                </Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={handleEditSubmit}>
                                <Modal.Body>
                                    <Row>
                                        <Col>
                                            <div className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Name <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Name"
                                                    name="name"
                                                    value={editedData?.name}
                                                    onChange={handleEditChange}
                                                />
                                                <div style={{ color: "red", fontSize: "12px" }}>
                                                    {editValidationErrors.name}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Email <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    placeholder="Email"
                                                    name="email"
                                                    value={editedData?.email}
                                                    onChange={handleEditChange}
                                                />
                                                <div style={{ color: "red", fontSize: "12px" }}>
                                                    {editValidationErrors.email}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Phone <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Phone"
                                                    className="no-arrows"
                                                    name="phone"
                                                    value={editedData?.phone}
                                                    onChange={handleEditChange}
                                                />
                                            </div>
                                        </Col>
                                        <Col md="3" lg="3">
                                            <Form.Label className="fw-semibold">
                                                Outlet Status <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select className='w-100' id="status" name="status" value={editedData?.status} onChange={handleEditChange}>
                                                <option value="" disabled>Select Outlet Status</option>
                                                <option value="ACTIVE">ACTIVE</option>
                                                <option value="INACTIVE">INACTIVE</option>
                                                <option value="COMING_SOON">COMING_SOON</option>
                                            </Form.Select>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <div className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Latitude <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Latitude"
                                                    className="no-arrows"
                                                    name="latitude"
                                                    value={editedData?.latitude}
                                                    onChange={handleEditChange}
                                                />
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Longitude <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Longitude"
                                                    className="no-arrows"
                                                    name="longitude"
                                                    value={editedData?.longitude}
                                                    onChange={handleEditChange}
                                                />
                                            </div>
                                        </Col>
                                        <Col md="2" lg="2">
                                            <div className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Opening Time
                                                </Form.Label>
                                                <Form.Control
                                                    type="time"
                                                    placeholder="Opening Time"
                                                    name="openingTime"
                                                    value={editedData?.openingTime}
                                                    onChange={handleEditChange}
                                                />
                                            </div>
                                        </Col>
                                        <Col md="2" lg="2">
                                            <div className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Closing Time
                                                </Form.Label>
                                                <Form.Control
                                                    type="time"
                                                    placeholder="Closing Time"
                                                    name="closingTime"
                                                    value={editedData?.closingTime}
                                                    onChange={handleEditChange}
                                                />
                                            </div>
                                        </Col>
                                        <Col md="2" lg="2">
                                            <Form.Label className="fw-semibold">
                                                Is Outlet Closed? <span className="text-danger">*</span>
                                            </Form.Label>
                                            <div className="d-flex">
                                                <Form.Check
                                                    type="switch"
                                                    id="formSwitchCheckDefault"
                                                    onChange={handleIsOutletClosedChange}
                                                    checked={editedData?.isOutletClosed}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md="4" lg="6">
                                            <div className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Full Address <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                    placeholder="Address"
                                                    name="address"
                                                    value={editedData?.address}
                                                    onChange={handleEditChange}
                                                />
                                                <div style={{ color: "red", fontSize: "12px" }}>
                                                    {editValidationErrors.address}
                                                </div>
                                            </div>
                                        </Col>

                                        <Col md="6" lg="3">
                                            <Form.Label className="fw-semibold">GSTIN <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="GSTIN"
                                                name="gstin"
                                                onChange={handleEditChange}
                                                value={editedData?.gstin}
                                            />
                                        </Col>
                                        <Col md="6" lg="3">
                                            <Form.Label className="fw-semibold">FSSAI</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="fssai"
                                                name="fssai"
                                                onChange={handleEditChange}
                                                value={editedData?.fssai}
                                            />
                                        </Col>

                                    </Row>
                                    <Row>
                                        <Col md="2" lg="3">
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    <span style={{ color: 'brown' }}>Accept Order In</span> <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Select
                                                    id="selectField"
                                                    name="orderAcceptType"
                                                    value={editedData.orderAcceptType}
                                                    onChange={handleEditChange}
                                                >
                                                    <option value="">Select Order Type</option>
                                                    <option value="ALL">ALL</option>
                                                    <option value="PICKUP">PICKUP</option>
                                                    <option value="DELIVERY">DELIVERY</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col md="2" lg="3">
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Delivery Radius (In Kms) <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    min={0}
                                                    type="number"
                                                    placeholder="Enter Minimum Delivery Radius (Kms)"
                                                    className="no-arrows"
                                                    name="minimumDeliveryRadius"
                                                    value={editedData.minimumDeliveryRadius}
                                                    onChange={handleEditChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col lg="3">
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Select Menu Group <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Select
                                                    id="selectField"
                                                    name="menuGroup"
                                                    value={editedData.menuGroup}
                                                    onChange={handleEditChange}
                                                >
                                                    <option value="">Select Menu Group</option>
                                                    {groups.map(group => (
                                                        <option key={group._id} value={group._id}>{group.groupName}</option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col md="2" lg="2">
                                            <Form.Label className="fw-semibold">
                                                Is It Event Outlet? <span className="text-danger">*</span>
                                            </Form.Label>
                                            <div className="d-flex">
                                                <Form.Check
                                                    type="switch"
                                                    id="formSwitchCheckDefault"
                                                    onChange={handleEditIsEventOutletChange}
                                                    checked={editedData?.isEventOutlet}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md="2" lg="2">
                                            <div className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Pincode <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Pincode"
                                                    className="no-arrows"
                                                    name="pincode"
                                                    value={editedData?.pincode}
                                                    onChange={handleEditChange}
                                                    onBlur={getEditPostalCodeDetails}
                                                />
                                                <div style={{ color: "red", fontSize: "12px" }}>
                                                    {editValidationErrors.pincode}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md="2" lg="2">
                                            <div className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    City <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="City"
                                                    name="city"
                                                    value={editedData?.city}
                                                    onChange={handleEditChange}
                                                />
                                                <div style={{ color: "red", fontSize: "12px" }}>
                                                    {editValidationErrors.city}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md="2" lg="2">
                                            <div className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    State <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="State"
                                                    name="state"
                                                    value={editedData?.state}
                                                    onChange={handleEditChange}
                                                />
                                                <div style={{ color: "red", fontSize: "12px" }}>
                                                    {editValidationErrors.state}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md="2" lg="2">
                                            <div className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Country <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Country"
                                                    name="country"
                                                    value={editedData.country}
                                                    onChange={handleEditChange}
                                                />
                                                <div style={{ color: "red", fontSize: "12px" }}>
                                                    {editValidationErrors.country}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md="2" lg="2">
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Select Outlet Type <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Select
                                                    id="selectField"
                                                    name="type"
                                                    value={editedData.type}
                                                    onChange={handleEditChange}
                                                >
                                                    <option value="">Select Type</option>
                                                    <option value="COMPANY_OWNED">COMPANY OWNED</option>
                                                    <option value="FRANCHISE">FRANCHISE OUTLET</option>
                                                    <option value="EVENT">EVENT OUTELT</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <>
                                        <h6>PAYMENT METHOD SETTINGS</h6>
                                        <hr className="mt-0" />
                                    </>
                                    <Row className="mb-3">
                                        <Col md="3" lg="3">
                                            <Form.Label className="fw-semibold">Select Payment Method <span className="text-danger">*</span></Form.Label>
                                            <Form.Select
                                                id="selectField"
                                                name="paymentType"
                                                value={editedData.paymentType}
                                                onChange={handleEditChange}
                                            >
                                                <option value="">Select Method</option>
                                                <option value="PAYMENT_GATEWAY">RAZOR PAY</option>
                                                <option value="CARD_SWIPE">PINE LABS MACHINE</option>
                                            </Form.Select>
                                        </Col>
                                        {editedData.paymentType === "CARD_SWIPE" ? (
                                            <>
                                                <Col>
                                                    <Form.Label className="fw-semibold">Merchant ID <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Merchant ID"
                                                        name="pineLabCredentials.merchantId"
                                                        value={editedData?.pineLabCredentials?.merchantId}
                                                        onChange={handleEditChange}
                                                    />
                                                </Col>
                                                <Col>
                                                    <Form.Label className="fw-semibold">Security Token <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Security Token"
                                                        name="pineLabCredentials.securityToken"
                                                        value={editedData?.pineLabCredentials?.securityToken}
                                                        onChange={handleEditChange}
                                                    />
                                                </Col>
                                                <Col>
                                                    <Form.Label className="fw-semibold">Client ID <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Client ID"
                                                        name="pineLabCredentials.clientId"
                                                        value={editedData?.pineLabCredentials?.clientId}
                                                        onChange={handleEditChange}
                                                    />
                                                </Col>
                                            </>
                                        ) : null}
                                    </Row>
                                    {editedData.paymentType === "CARD_SWIPE" ? (
                                        <Row className="mb-3">
                                            <Col md="3" lg="3">
                                                <Form.Label className="fw-semibold">
                                                    Store ID <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Client ID"
                                                    name="pineLabCredentials.storeId"
                                                    value={editedData?.pineLabCredentials?.storeId}
                                                    onChange={handleEditChange}
                                                />
                                            </Col>
                                        </Row>
                                    ) : null}
                                    <>
                                        <h6>DELIVERY PLATFORMS</h6>
                                        <hr className="mt-0" />
                                    </>
                                    {(Array.isArray(editedData?.platForms) && editedData?.platForms.length > 0 ? editedData.platForms : [{ name: '', webLink: '' }]).map((platform, index) => (
                                        <Row key={index}>
                                            <Col md="5">
                                                <div className="mb-3">
                                                    <Form.Label className="fw-semibold">Name</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Platform Name"
                                                        name="platformName"
                                                        value={platform.name}
                                                        onChange={(e) => handleEditChange(e, index)}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md="5">
                                                <div className="mb-3">
                                                    <Form.Label className="fw-semibold">Weblink</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Weblink"
                                                        name="platformWeblink"
                                                        value={platform.webLink}
                                                        onChange={(e) => handleEditChange(e, index)}
                                                    />
                                                </div>
                                            </Col>
                                            <Col>
                                                {editedData?.platForms?.length === 1 ? (
                                                    <>
                                                        <Button
                                                            onClick={() => handleAddEditItem()}
                                                            variant="primary"
                                                            style={{ borderRadius: "18px" }}
                                                        >
                                                            <i className="ri-add-fill fs-4"></i>
                                                        </Button>
                                                        <Button
                                                            variant="primary"
                                                            onClick={() => handleRemoveEditItem(index)}
                                                            style={{ borderRadius: "18px", marginLeft: '4px' }}
                                                        >
                                                            <i className="ri-subtract-fill fs-4"></i>
                                                        </Button>
                                                    </>
                                                ) : (
                                                    <>
                                                        {index === editedData?.platForms?.length - 1 && (
                                                            <Button
                                                                variant="primary"
                                                                style={{ borderRadius: "18px" }}
                                                                onClick={() => handleAddEditItem()}
                                                            >
                                                                <i className="ri-subtract-fill fs-4"></i>
                                                            </Button>
                                                        )}
                                                        <Button
                                                            variant="primary"
                                                            style={{ borderRadius: "18px", marginRight: '4px' }}
                                                            onClick={() => handleRemoveEditItem(index)}
                                                        >
                                                            <i className="ri-subtract-fill fs-4"></i>
                                                        </Button>
                                                    </>
                                                )}
                                            </Col>
                                        </Row>
                                    ))}
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="primary" type="submit" disabled={isEditBtnLoading}>
                                        {isEditBtnLoading ? 'Saving...' : 'SAVE CHANGES'}
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    ) : null} */}
                    {/* <------------- Edit Outlets Modal -------------->  */}
                    {openEditModal ? (
                        <Modal
                            size="xl"
                            centered
                            show={openEditModal}
                            onHide={() => setOpenEditModal(false)}
                            aria-labelledby="edit-outlet-modal"
                        >
                            <Modal.Header style={{ backgroundColor: "#F5F5F5" }} closeButton>
                                <Modal.Title className="fs-4 text-dark">
                                    EDIT OUTLET
                                </Modal.Title>
                            </Modal.Header>

                            <Form onSubmit={handleEditSubmit}>
                                <Modal.Body>
                                    {/* Basic Information Section */}
                                    <div className="mb-4">
                                        <h6 className="fw-semibold text-primary">BASIC INFORMATION</h6>
                                        <hr className="mt-1" />
                                        <Row>
                                            <Col md="6" lg="3">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Outlet Name <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Outlet name"
                                                        name="name"
                                                        value={editedData?.name}
                                                        onChange={handleEditChange}
                                                    />
                                                    {editValidationErrors.name && (
                                                        <Form.Text className="text-danger">
                                                            {editValidationErrors.name}
                                                        </Form.Text>
                                                    )}
                                                </Form.Group>
                                            </Col>

                                            <Col md="6" lg="3">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Email <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="email"
                                                        placeholder="email@example.com"
                                                        name="email"
                                                        value={editedData?.email}
                                                        onChange={handleEditChange}
                                                    />
                                                    {editValidationErrors.email && (
                                                        <Form.Text className="text-danger">
                                                            {editValidationErrors.email}
                                                        </Form.Text>
                                                    )}
                                                </Form.Group>
                                            </Col>

                                            <Col md="6" lg="3">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Phone <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        placeholder="Phone number"
                                                        className="no-arrows"
                                                        name="phone"
                                                        value={editedData?.phone}
                                                        onChange={handleEditChange}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md="6" lg="3">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Outlet Status <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Select
                                                        name="status"
                                                        value={editedData?.status}
                                                        onChange={handleEditChange}
                                                    >
                                                        <option value="" disabled>Select status</option>
                                                        <option value="ACTIVE">Active</option>
                                                        <option value="INACTIVE">Inactive</option>
                                                        <option value="COMING_SOON">Coming Soon</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </div>

                                    {/* Location & Coordinates */}
                                    <div className="mb-4">
                                        <h6 className="fw-semibold text-primary">LOCATION & COORDINATES</h6>
                                        <hr className="mt-1" />
                                        <Row>
                                            <Col md="6" lg="6">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Full Address <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={3}
                                                        placeholder="Complete address"
                                                        name="address"
                                                        value={editedData?.address}
                                                        onChange={handleEditChange}
                                                    />
                                                    {editValidationErrors.address && (
                                                        <Form.Text className="text-danger">
                                                            {editValidationErrors.address}
                                                        </Form.Text>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                            <Col md="3" lg="3">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Latitude <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        placeholder="Latitude"
                                                        className="no-arrows"
                                                        name="latitude"
                                                        value={editedData?.latitude}
                                                        onChange={handleEditChange}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md="3" lg="3">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Longitude <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        placeholder="Longitude"
                                                        className="no-arrows"
                                                        name="longitude"
                                                        value={editedData?.longitude}
                                                        onChange={handleEditChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md="6" lg="3">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Pincode <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        placeholder="Pincode"
                                                        className="no-arrows"
                                                        name="pincode"
                                                        value={editedData?.pincode}
                                                        onChange={handleEditChange}
                                                        onBlur={getEditPostalCodeDetails}
                                                    />
                                                    {editValidationErrors.pincode && (
                                                        <Form.Text className="text-danger">
                                                            {editValidationErrors.pincode}
                                                        </Form.Text>
                                                    )}
                                                </Form.Group>
                                            </Col>

                                            <Col md="6" lg="3">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        City <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="City"
                                                        name="city"
                                                        value={editedData?.city}
                                                        onChange={handleEditChange}
                                                    />
                                                    {editValidationErrors.city && (
                                                        <Form.Text className="text-danger">
                                                            {editValidationErrors.city}
                                                        </Form.Text>
                                                    )}
                                                </Form.Group>
                                            </Col>

                                            <Col md="6" lg="3">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        State <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="State"
                                                        name="state"
                                                        value={editedData?.state}
                                                        onChange={handleEditChange}
                                                    />
                                                    {editValidationErrors.state && (
                                                        <Form.Text className="text-danger">
                                                            {editValidationErrors.state}
                                                        </Form.Text>
                                                    )}
                                                </Form.Group>
                                            </Col>

                                            <Col md="6" lg="3">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Country <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Country"
                                                        name="country"
                                                        value={editedData?.country}
                                                        onChange={handleEditChange}
                                                    />
                                                    {editValidationErrors.country && (
                                                        <Form.Text className="text-danger">
                                                            {editValidationErrors.country}
                                                        </Form.Text>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </div>

                                    {/* Operation Settings */}
                                    <div className="mb-4">
                                        <h6 className="fw-semibold text-primary">OPERATION SETTINGS</h6>
                                        <hr className="mt-1" />
                                        <Row>
                                            <Col md="6" lg="3">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Menu Group <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Select
                                                        name="menuGroup"
                                                        value={editedData?.menuGroup}
                                                        onChange={handleEditChange}
                                                    >
                                                        <option value="">Select menu group</option>
                                                        {groups.map(group => (
                                                            <option key={group._id} value={group._id}>
                                                                {group.groupName}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>

                                            <Col md="6" lg="3">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Outlet Type <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Select
                                                        name="type"
                                                        value={editedData?.type}
                                                        onChange={handleEditChange}
                                                    >
                                                        <option value="">Select type</option>
                                                        <option value="COMPANY_OWNED">Company Owned</option>
                                                        <option value="FRANCHISE">Franchise Outlet</option>
                                                        <option value="EVENT">Event Outlet</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>

                                            <Col md="6" lg="3">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Order Acceptance <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Select
                                                        name="orderAcceptType"
                                                        value={editedData?.orderAcceptType}
                                                        onChange={handleEditChange}
                                                    >
                                                        <option value="">Select order type</option>
                                                        <option value="ALL">All Orders</option>
                                                        <option value="PICKUP">Pickup Only</option>
                                                        <option value="DELIVERY">Delivery Only</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>

                                            <Col md="6" lg="3">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Delivery Radius (km) <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        min={0}
                                                        type="number"
                                                        placeholder="Radius in km"
                                                        className="no-arrows"
                                                        name="minimumDeliveryRadius"
                                                        value={editedData?.minimumDeliveryRadius}
                                                        onChange={handleEditChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md="4" lg="2">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">Opening Time</Form.Label>
                                                    <Form.Control
                                                        type="time"
                                                        name="openingTime"
                                                        value={editedData?.openingTime}
                                                        onChange={handleEditChange}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md="4" lg="2">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">Closing Time</Form.Label>
                                                    <Form.Control
                                                        type="time"
                                                        name="closingTime"
                                                        value={editedData?.closingTime}
                                                        onChange={handleEditChange}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md="4" lg="2">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Outlet Closed? <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <div className="mt-2">
                                                        <Form.Check
                                                            type="switch"
                                                            id="outletClosedSwitch"
                                                            onChange={handleIsOutletClosedChange}
                                                            checked={editedData?.isOutletClosed}
                                                            label={editedData?.isOutletClosed ? "Yes" : "No"}
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Col>

                                            <Col md="4" lg="2">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Event Outlet? <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <div className="mt-2">
                                                        <Form.Check
                                                            type="switch"
                                                            id="eventOutletSwitch"
                                                            onChange={handleEditIsEventOutletChange}
                                                            checked={editedData?.isEventOutlet}
                                                            label={editedData?.isEventOutlet ? "Yes" : "No"}
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </div>

                                    {/* Business & Legal Information */}
                                    <div className="mb-4">
                                        <h6 className="fw-semibold text-primary">BUSINESS & LEGAL</h6>
                                        <hr className="mt-1" />
                                        <Row>
                                            <Col md="6" lg="4">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        GSTIN <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="GSTIN number"
                                                        name="gstin"
                                                        value={editedData?.gstin}
                                                        onChange={handleEditChange}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md="6" lg="4">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">FSSAI License</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="FSSAI number"
                                                        name="fssai"
                                                        value={editedData?.fssai}
                                                        onChange={handleEditChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        {/* Unit Selection Fields - ADDED FOR EDIT MODAL */}
                                        <Row>
                                            <Col md="4" lg="4">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Food Unit <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Select
                                                        options={foodUnitOptions}
                                                        value={foodUnitOptions?.find(option => option.value === editedData.foodUnitId)}
                                                        onChange={(selectedOption) => handleEditUnitChange('foodUnitId', selectedOption)}
                                                        placeholder="Select Food Unit"
                                                        isSearchable
                                                        components={animatedComponents}
                                                        styles={customSelectStyles}
                                                        isClearable
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md="4" lg="4">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Beverage Unit <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Select
                                                        options={beverageUnitOptions}
                                                        value={beverageUnitOptions?.find(option => option.value === editedData.beverageUnitId)}
                                                        onChange={(selectedOption) => handleEditUnitChange('beverageUnitId', selectedOption)}
                                                        placeholder="Select Beverage Unit"
                                                        isSearchable
                                                        components={animatedComponents}
                                                        styles={customSelectStyles}
                                                        isClearable
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md="4" lg="4">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Central Unit <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Select
                                                        options={centralUnitOptions}
                                                        value={centralUnitOptions?.find(option => option.value === editedData.centralUnitId)}
                                                        onChange={(selectedOption) => handleEditUnitChange('centralUnitId', selectedOption)}
                                                        placeholder="Select Central Unit"
                                                        isSearchable
                                                        styles={customSelectStyles}
                                                        components={animatedComponents}
                                                        isClearable
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </div>

                                    {/* Payment Method Settings */}
                                    <div className="mb-4">
                                        <h6 className="fw-semibold text-primary">PAYMENT METHOD</h6>
                                        <hr className="mt-1" />
                                        <Row>
                                            <Col md="6" lg="4">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Payment Method <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Select
                                                        name="paymentType"
                                                        value={editedData?.paymentType}
                                                        onChange={handleEditChange}
                                                    >
                                                        <option value="">Select payment method</option>
                                                        <option value="PAYMENT_GATEWAY">Razor Pay</option>
                                                        <option value="CARD_SWIPE">Pine Labs Machine</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        {editedData?.paymentType === "CARD_SWIPE" && (
                                            <Row>
                                                <Col md="6" lg="3">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="fw-semibold">
                                                            Merchant ID <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Merchant ID"
                                                            name="pineLabCredentials.merchantId"
                                                            value={editedData?.pineLabCredentials?.merchantId}
                                                            onChange={handleEditChange}
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col md="6" lg="3">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="fw-semibold">
                                                            Security Token <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Security Token"
                                                            name="pineLabCredentials.securityToken"
                                                            value={editedData?.pineLabCredentials?.securityToken}
                                                            onChange={handleEditChange}
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col md="6" lg="3">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="fw-semibold">
                                                            Client ID <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Client ID"
                                                            name="pineLabCredentials.clientId"
                                                            value={editedData?.pineLabCredentials?.clientId}
                                                            onChange={handleEditChange}
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col md="6" lg="3">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="fw-semibold">
                                                            Store ID <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Store ID"
                                                            name="pineLabCredentials.storeId"
                                                            value={editedData?.pineLabCredentials?.storeId}
                                                            onChange={handleEditChange}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        )}
                                    </div>

                                    {/* Delivery Platforms */}
                                    <div className="mb-3">
                                        <h6 className="fw-semibold text-primary">DELIVERY PLATFORMS</h6>
                                        <hr className="mt-1" />
                                        {(Array.isArray(editedData?.platForms) && editedData?.platForms.length > 0 ? editedData.platForms : [{ name: '', webLink: '' }]).map((platform, index) => (
                                            <div key={index} className="mb-3 p-3 border rounded">
                                                <Row className="align-items-end">
                                                    <Col md="5">
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className="fw-semibold">Platform Name</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Platform name"
                                                                name="platformName"
                                                                value={platform.name}
                                                                onChange={(e) => handleEditChange(e, index)}
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md="5">
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className="fw-semibold">Website Link</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="https://example.com"
                                                                name="platformWeblink"
                                                                value={platform.webLink}
                                                                onChange={(e) => handleEditChange(e, index)}
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md="2">
                                                        <div className="d-flex gap-2 mb-3">
                                                            {index === (editedData?.platForms?.length || 1) - 1 && (
                                                                <Button
                                                                    size="sm"
                                                                    onClick={() => handleAddEditItem()}
                                                                    variant="outline-success"
                                                                    className="rounded-circle"
                                                                    title="Add platform"
                                                                >
                                                                    <i className="ri-add-line"></i>
                                                                </Button>
                                                            )}

                                                            {(editedData?.platForms?.length || 1) > 1 && (
                                                                <Button
                                                                    size="sm"
                                                                    onClick={() => handleRemoveEditItem(index)}
                                                                    variant="outline-danger"
                                                                    className="rounded-circle"
                                                                    title="Remove platform"
                                                                >
                                                                    <i className="ri-subtract-line"></i>
                                                                </Button>
                                                            )}
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        ))}
                                    </div>
                                </Modal.Body>

                                <Modal.Footer className="border-top pt-3">
                                    <Button
                                        variant="outline-secondary"
                                        onClick={() => setOpenEditModal(false)}
                                        className="me-2"
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="primary"
                                        type="submit"
                                        disabled={isEditBtnLoading}
                                        className="px-4"
                                    >
                                        {isEditBtnLoading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" />
                                                Saving Changes...
                                            </>
                                        ) : (
                                            'Save Changes'
                                        )}
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    ) : null}

                    {/* <------------- View Outlets Modal ------------> */}
                    {openViewModal ? (
                        <Modal
                            size="xl"
                            show={openViewModal}
                            onHide={() => setOpenViewModal(false)}
                            centered
                            aria-labelledby="profile-modal"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title id="profile-modal">Outlet Profile</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Row className="align-items-center">
                                    {/* Profile Image Section */}
                                    <Col md={4} className="text-center">
                                        <img
                                            src={outletDetails?.outletImage}
                                            alt="outlet-img"
                                            className="img-fluid rounded-circle mb-3"
                                            style={{ width: "180px", height: "180px", objectFit: "cover" }}
                                        />
                                        <Button
                                            variant="primary"
                                            className="w-100"
                                            style={{ marginTop: '60px' }}
                                            onClick={() => handleOpenImageChangeModal(outletDetails?._id)}
                                        >
                                            Change Image
                                        </Button>
                                    </Col>

                                    {/* Basic Details */}
                                    <Col md={8}>
                                        <h5 className="fw-bold mb-3">Outlet Details</h5>
                                        <Table borderless className="mb-4">
                                            <tbody>
                                                <tr>
                                                    <td className="fw-bold">Name</td>
                                                    <td>{outletDetails?.name}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold">Email</td>
                                                    <td>{outletDetails?.email}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold">Phone</td>
                                                    <td>{outletDetails?.phone}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold">Address</td>
                                                    <td>{outletDetails?.address}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold">City</td>
                                                    <td>{outletDetails?.city}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold">Pincode</td>
                                                    <td>{outletDetails?.pincode}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold">State</td>
                                                    <td>{outletDetails?.state}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold">Country</td>
                                                    <td>{outletDetails?.country}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold">GST</td>
                                                    <td>{outletDetails?.country}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold">Country</td>
                                                    <td>{outletDetails?.country}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                                <hr />
                                {/* Status and Timing */}
                                <Row className="mt-4">
                                    <Col>
                                        <h5 className="fw-bold">Status & Timing</h5>
                                        <Table borderless>
                                            <tbody>
                                                <tr>
                                                    <td className="fw-bold">Outlet Type</td>
                                                    <td>{outletDetails ? outletDetails?.type : 'Will Be Updated Soon'}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold">Accepting Orders IN</td>
                                                    <td
                                                        className={`fw-bold ${outletDetails?.orderAcceptType === "PICKUP"
                                                            ? "text-danger"
                                                            : outletDetails?.orderAcceptType === "DELIVERY"
                                                                ? "text-success"
                                                                : ""
                                                            }`}

                                                    >
                                                        {outletDetails?.orderAcceptType}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold">Status</td>
                                                    <td
                                                        className={`fw-bold ${outletDetails?.status === "INACTIVE"
                                                            ? "text-danger"
                                                            : "text-success"
                                                            }`}
                                                    >
                                                        {outletDetails?.status}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold">Minimum Radius For Delivery</td>
                                                    <td>{outletDetails?.minimumDeliveryRadius ? `${outletDetails?.minimumDeliveryRadius} Kms` : "Not Provided"}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold">Opening Time</td>
                                                    <td>{formatTime(outletDetails?.openingTime)}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold">Closing Time</td>
                                                    <td>{formatTime(outletDetails?.closingTime)}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold">Is Outlet Closed</td>
                                                    <td
                                                        className={`fw-bold ${outletDetails?.isOutletClosed ? "text-danger" : "text-success"
                                                            }`}
                                                    >
                                                        {outletDetails?.isOutletClosed ? "CLOSED" : "OPEN"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold">Outlet Type</td>
                                                    <td style={{ color: "brown" }}>
                                                        {outletDetails?.isEventOutlet
                                                            ? "Event Outlet"
                                                            : "Regular Outlet"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold">Menu Group</td>
                                                    <td className="fw-semibold">
                                                        {outletDetails?.menuGroup
                                                            ? outletDetails?.menuGroup?.groupName : "ALL GROUPS"}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                                <hr />
                                {/* Payment Method */}
                                <Row>
                                    <Col>
                                        <h5 className="fw-bold">Payment Method Details</h5>
                                        <Table borderless>
                                            <tbody>
                                                <tr>
                                                    <td className="fw-bold">Payment Type</td>
                                                    <td>{outletDetails?.paymentType}</td>
                                                </tr>
                                                {outletDetails?.paymentType === "CARD_SWIPE" ? (
                                                    <>
                                                        <tr>
                                                            <td className="fw-bold">Merchant Id</td>
                                                            <td>{outletDetails?.pineLabCredentials?.merchantId}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-bold">Client Id</td>
                                                            <td>{outletDetails?.pineLabCredentials?.clientId}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-bold">Security Token</td>
                                                            <td>{outletDetails?.pineLabCredentials?.securityToken}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-bold">Store Id</td>
                                                            <td>{outletDetails?.pineLabCredentials?.storeId}</td>
                                                        </tr>
                                                    </>
                                                ) : null}
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                                <hr />
                                {/* Delivery Platforms */}
                                {outletDetails?.platForms?.length > 0 && (
                                    <Row className="mt-4">
                                        <Col>
                                            <h5 className="fw-bold">Delivery Platforms</h5>
                                            <Table striped bordered hover className="text-center">
                                                <thead>
                                                    <tr>
                                                        <th>Platform Name</th>
                                                        <th>Platform Weblink</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {outletDetails?.platForms?.map((platform, index) => (
                                                        <tr key={index}>
                                                            <td>{platform.name}</td>
                                                            <td>
                                                                <a
                                                                    href={platform.webLink}
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                >
                                                                    {platform.webLink}
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                )}

                                {/* Google Map */}
                                {isLoaded && (
                                    <Row className="mt-4">
                                        <Col>
                                            <h5 className="fw-bold">Location</h5>
                                            <div style={{ width: "100%", height: "400px" }}>
                                                <GoogleMap
                                                    mapContainerStyle={containerStyle}
                                                    center={center}
                                                    zoom={10}
                                                    onLoad={onLoad}
                                                    onUnmount={onUnmount}
                                                >
                                                    <MarkerF position={center} title={center.name} />
                                                </GoogleMap>
                                            </div>
                                        </Col>
                                    </Row>
                                )}
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="primary"
                                    onClick={() => setOpenViewModal(false)}
                                >
                                    CLOSE
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    ) : null}

                    {/* <------------- Update Image Modal ------------> */}
                    {openUpdateImageModal ? (
                        <Modal
                            centered
                            show={openUpdateImageModal}
                            onHide={() => setOpenUpdateImageModal(false)}
                            aria-labelledby="update-image-modal"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title id="update-image-modal" className="fs-6">
                                    UPDATE IMAGE
                                </Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={handleUpdateImage}>
                                <Modal.Body>
                                    <Form.Group controlId="formFile" className="mb-3">
                                        <Form.Label>
                                            Choose File <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="file"
                                            onChange={handleEditImageChange}
                                            className="form-control"
                                        />
                                        <Form.Text className="text-success">
                                            Choose an image with dimensions equal to 1410x1100
                                        </Form.Text>
                                    </Form.Group>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button
                                        type="submit"
                                        variant="primary"
                                        className="rounded-pill"
                                        disabled={isUpdateImageBtnLoading}
                                    >
                                        {isUpdateImageBtnLoading ? <Spinner size="sm" /> : "Save Changes"}
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    ) : null}

                    {/* <---------------- Delete Outlet Modal ------------> */}
                    <Modal show={openDeleteModal} onHide={handleCloseDeleteModal} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirm Delete</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Are you sure you want to delete this outlet? This action cannot be undone.
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseDeleteModal}>
                                Cancel
                            </Button>
                            <Button variant="danger" onClick={deleteOutlet}>
                                {isDeleteLoading ?
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    /> :
                                    "Delete Outlet"
                                }
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Outlets;
